import { enumScannerSortOption } from '@rematter/frontend-lib-api-client';

import { scannersListQueryAtom } from '../_graphql/queryScannersList';

export const $remoteScanners = scannersListQueryAtom(() => ({
  variables: {
    sorting: [enumScannerSortOption.NameAsc],
  },
}));
